import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight, User, Users, BookOpen, Heart, Globe, Smile, Flag, Mic, Gauge, Check, Home, Users2, GraduationCap, Zap, Lightbulb, Info, Sparkles } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import api from '../config/api';
import toast from 'react-hot-toast';
import UpgradeModal from '../components/UpgradeModal';
import { useAuth } from '../context/AuthContext';

// Comprehensive list of all countries
const COUNTRIES = [
  { code: 'us', name: 'United States' },
  { code: 'ca', name: 'Canada' },
  { code: 'uk', name: 'United Kingdom' },
  { code: 'au', name: 'Australia' },
  { code: 'nz', name: 'New Zealand' },
  { code: 'ie', name: 'Ireland' },
  { code: 'af', name: 'Afghanistan' },
  { code: 'al', name: 'Albania' },
  { code: 'dz', name: 'Algeria' },
  { code: 'as', name: 'American Samoa' },
  { code: 'ad', name: 'Andorra' },
  { code: 'ao', name: 'Angola' },
  { code: 'ai', name: 'Anguilla' },
  { code: 'aq', name: 'Antarctica' },
  { code: 'ag', name: 'Antigua and Barbuda' },
  { code: 'ar', name: 'Argentina' },
  { code: 'am', name: 'Armenia' },
  { code: 'aw', name: 'Aruba' },
  { code: 'at', name: 'Austria' },
  { code: 'az', name: 'Azerbaijan' },
  { code: 'bs', name: 'Bahamas' },
  { code: 'bh', name: 'Bahrain' },
  { code: 'bd', name: 'Bangladesh' },
  { code: 'bb', name: 'Barbados' },
  { code: 'by', name: 'Belarus' },
  { code: 'be', name: 'Belgium' },
  { code: 'bz', name: 'Belize' },
  { code: 'bj', name: 'Benin' },
  { code: 'bm', name: 'Bermuda' },
  { code: 'bt', name: 'Bhutan' },
  { code: 'bo', name: 'Bolivia' },
  { code: 'ba', name: 'Bosnia and Herzegovina' },
  { code: 'bw', name: 'Botswana' },
  { code: 'bv', name: 'Bouvet Island' },
  { code: 'br', name: 'Brazil' },
  { code: 'io', name: 'British Indian Ocean Territory' },
  { code: 'bn', name: 'Brunei Darussalam' },
  { code: 'bg', name: 'Bulgaria' },
  { code: 'bf', name: 'Burkina Faso' },
  { code: 'bi', name: 'Burundi' },
  { code: 'kh', name: 'Cambodia' },
  { code: 'cm', name: 'Cameroon' },
  { code: 'cv', name: 'Cape Verde' },
  { code: 'ky', name: 'Cayman Islands' },
  { code: 'cf', name: 'Central African Republic' },
  { code: 'td', name: 'Chad' },
  { code: 'cl', name: 'Chile' },
  { code: 'cn', name: 'China' },
  { code: 'cx', name: 'Christmas Island' },
  { code: 'cc', name: 'Cocos (Keeling) Islands' },
  { code: 'co', name: 'Colombia' },
  { code: 'km', name: 'Comoros' },
  { code: 'cg', name: 'Congo' },
  { code: 'cd', name: 'Congo, Democratic Republic' },
  { code: 'ck', name: 'Cook Islands' },
  { code: 'cr', name: 'Costa Rica' },
  { code: 'ci', name: "Côte d'Ivoire" },
  { code: 'hr', name: 'Croatia' },
  { code: 'cu', name: 'Cuba' },
  { code: 'cy', name: 'Cyprus' },
  { code: 'cz', name: 'Czech Republic' },
  { code: 'dk', name: 'Denmark' },
  { code: 'dj', name: 'Djibouti' },
  { code: 'dm', name: 'Dominica' },
  { code: 'do', name: 'Dominican Republic' },
  { code: 'ec', name: 'Ecuador' },
  { code: 'eg', name: 'Egypt' },
  { code: 'sv', name: 'El Salvador' },
  { code: 'gq', name: 'Equatorial Guinea' },
  { code: 'er', name: 'Eritrea' },
  { code: 'ee', name: 'Estonia' },
  { code: 'et', name: 'Ethiopia' },
  { code: 'fk', name: 'Falkland Islands (Malvinas)' },
  { code: 'fo', name: 'Faroe Islands' },
  { code: 'fj', name: 'Fiji' },
  { code: 'fi', name: 'Finland' },
  { code: 'fr', name: 'France' },
  { code: 'gf', name: 'French Guiana' },
  { code: 'pf', name: 'French Polynesia' },
  { code: 'tf', name: 'French Southern Territories' },
  { code: 'ga', name: 'Gabon' },
  { code: 'gm', name: 'Gambia' },
  { code: 'ge', name: 'Georgia' },
  { code: 'de', name: 'Germany' },
  { code: 'gh', name: 'Ghana' },
  { code: 'gi', name: 'Gibraltar' },
  { code: 'gr', name: 'Greece' },
  { code: 'gl', name: 'Greenland' },
  { code: 'gd', name: 'Grenada' },
  { code: 'gp', name: 'Guadeloupe' },
  { code: 'gu', name: 'Guam' },
  { code: 'gt', name: 'Guatemala' },
  { code: 'gn', name: 'Guinea' },
  { code: 'gw', name: 'Guinea-Bissau' },
  { code: 'gy', name: 'Guyana' },
  { code: 'ht', name: 'Haiti' },
  { code: 'hm', name: 'Heard Island and McDonald Islands' },
  { code: 'va', name: 'Holy See (Vatican City)' },
  { code: 'hn', name: 'Honduras' },
  { code: 'hk', name: 'Hong Kong' },
  { code: 'hu', name: 'Hungary' },
  { code: 'is', name: 'Iceland' },
  { code: 'in', name: 'India' },
  { code: 'id', name: 'Indonesia' },
  { code: 'ir', name: 'Iran' },
  { code: 'iq', name: 'Iraq' },
  { code: 'il', name: 'Israel' },
  { code: 'it', name: 'Italy' },
  { code: 'jm', name: 'Jamaica' },
  { code: 'jp', name: 'Japan' },
  { code: 'jo', name: 'Jordan' },
  { code: 'kz', name: 'Kazakhstan' },
  { code: 'ke', name: 'Kenya' },
  { code: 'ki', name: 'Kiribati' },
  { code: 'kp', name: "Korea, Democratic People's Republic" },
  { code: 'kr', name: 'Korea, Republic of' },
  { code: 'kw', name: 'Kuwait' },
  { code: 'kg', name: 'Kyrgyzstan' },
  { code: 'la', name: "Lao People's Democratic Republic" },
  { code: 'lv', name: 'Latvia' },
  { code: 'lb', name: 'Lebanon' },
  { code: 'ls', name: 'Lesotho' },
  { code: 'lr', name: 'Liberia' },
  { code: 'ly', name: 'Libya' },
  { code: 'li', name: 'Liechtenstein' },
  { code: 'lt', name: 'Lithuania' },
  { code: 'lu', name: 'Luxembourg' },
  { code: 'mo', name: 'Macao' },
  { code: 'mk', name: 'North Macedonia' },
  { code: 'mg', name: 'Madagascar' },
  { code: 'mw', name: 'Malawi' },
  { code: 'my', name: 'Malaysia' },
  { code: 'mv', name: 'Maldives' },
  { code: 'ml', name: 'Mali' },
  { code: 'mt', name: 'Malta' },
  { code: 'mh', name: 'Marshall Islands' },
  { code: 'mq', name: 'Martinique' },
  { code: 'mr', name: 'Mauritania' },
  { code: 'mu', name: 'Mauritius' },
  { code: 'yt', name: 'Mayotte' },
  { code: 'mx', name: 'Mexico' },
  { code: 'fm', name: 'Micronesia' },
  { code: 'md', name: 'Moldova' },
  { code: 'mc', name: 'Monaco' },
  { code: 'mn', name: 'Mongolia' },
  { code: 'me', name: 'Montenegro' },
  { code: 'ms', name: 'Montserrat' },
  { code: 'ma', name: 'Morocco' },
  { code: 'mz', name: 'Mozambique' },
  { code: 'mm', name: 'Myanmar' },
  { code: 'na', name: 'Namibia' },
  { code: 'nr', name: 'Nauru' },
  { code: 'np', name: 'Nepal' },
  { code: 'nl', name: 'Netherlands' },
  { code: 'nc', name: 'New Caledonia' },
  { code: 'ni', name: 'Nicaragua' },
  { code: 'ne', name: 'Niger' },
  { code: 'ng', name: 'Nigeria' },
  { code: 'nu', name: 'Niue' },
  { code: 'nf', name: 'Norfolk Island' },
  { code: 'mp', name: 'Northern Mariana Islands' },
  { code: 'no', name: 'Norway' },
  { code: 'om', name: 'Oman' },
  { code: 'pk', name: 'Pakistan' },
  { code: 'pw', name: 'Palau' },
  { code: 'ps', name: 'Palestine' },
  { code: 'pa', name: 'Panama' },
  { code: 'pg', name: 'Papua New Guinea' },
  { code: 'py', name: 'Paraguay' },
  { code: 'pe', name: 'Peru' },
  { code: 'ph', name: 'Philippines' },
  { code: 'pn', name: 'Pitcairn' },
  { code: 'pl', name: 'Poland' },
  { code: 'pt', name: 'Portugal' },
  { code: 'pr', name: 'Puerto Rico' },
  { code: 'qa', name: 'Qatar' },
  { code: 're', name: 'Réunion' },
  { code: 'ro', name: 'Romania' },
  { code: 'ru', name: 'Russian Federation' },
  { code: 'rw', name: 'Rwanda' },
  { code: 'sh', name: 'Saint Helena' },
  { code: 'kn', name: 'Saint Kitts and Nevis' },
  { code: 'lc', name: 'Saint Lucia' },
  { code: 'pm', name: 'Saint Pierre and Miquelon' },
  { code: 'vc', name: 'Saint Vincent and the Grenadines' },
  { code: 'ws', name: 'Samoa' },
  { code: 'sm', name: 'San Marino' },
  { code: 'st', name: 'Sao Tome and Principe' },
  { code: 'sa', name: 'Saudi Arabia' },
  { code: 'sn', name: 'Senegal' },
  { code: 'rs', name: 'Serbia' },
  { code: 'sc', name: 'Seychelles' },
  { code: 'sl', name: 'Sierra Leone' },
  { code: 'sg', name: 'Singapore' },
  { code: 'sk', name: 'Slovakia' },
  { code: 'si', name: 'Slovenia' },
  { code: 'sb', name: 'Solomon Islands' },
  { code: 'so', name: 'Somalia' },
  { code: 'za', name: 'South Africa' },
  { code: 'gs', name: 'South Georgia and the South Sandwich Islands' },
  { code: 'es', name: 'Spain' },
  { code: 'lk', name: 'Sri Lanka' },
  { code: 'sd', name: 'Sudan' },
  { code: 'sr', name: 'Suriname' },
  { code: 'sj', name: 'Svalbard and Jan Mayen' },
  { code: 'sz', name: 'Swaziland' },
  { code: 'se', name: 'Sweden' },
  { code: 'ch', name: 'Switzerland' },
  { code: 'sy', name: 'Syrian Arab Republic' },
  { code: 'tw', name: 'Taiwan' },
  { code: 'tj', name: 'Tajikistan' },
  { code: 'tz', name: 'Tanzania' },
  { code: 'th', name: 'Thailand' },
  { code: 'tl', name: 'Timor-Leste' },
  { code: 'tg', name: 'Togo' },
  { code: 'tk', name: 'Tokelau' },
  { code: 'to', name: 'Tonga' },
  { code: 'tt', name: 'Trinidad and Tobago' },
  { code: 'tn', name: 'Tunisia' },
  { code: 'tr', name: 'Turkey' },
  { code: 'tm', name: 'Turkmenistan' },
  { code: 'tc', name: 'Turks and Caicos Islands' },
  { code: 'tv', name: 'Tuvalu' },
  { code: 'ug', name: 'Uganda' },
  { code: 'ua', name: 'Ukraine' },
  { code: 'ae', name: 'United Arab Emirates' },
  { code: 'um', name: 'United States Minor Outlying Islands' },
  { code: 'uy', name: 'Uruguay' },
  { code: 'uz', name: 'Uzbekistan' },
  { code: 'vu', name: 'Vanuatu' },
  { code: 've', name: 'Venezuela' },
  { code: 'vn', name: 'Vietnam' },
  { code: 'vg', name: 'Virgin Islands, British' },
  { code: 'vi', name: 'Virgin Islands, U.S.' },
  { code: 'wf', name: 'Wallis and Futuna' },
  { code: 'eh', name: 'Western Sahara' },
  { code: 'ye', name: 'Yemen' },
  { code: 'zm', name: 'Zambia' },
  { code: 'zw', name: 'Zimbabwe' },
].sort((a, b) => {
  // Keep United States at the top
  if (a.code === 'us') return -1;
  if (b.code === 'us') return 1;
  // Sort the rest alphabetically
  return a.name.localeCompare(b.name);
});

const ProfileWizard = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    gender: '',
    dateOfBirth: '',
    age: '',
    ethnicity: '',
    country: '',
    language: 'english',
    tone: 'entertaining',
    ending: 'happy',
    voice: 'male',
    readingSpeed: 'normal',
    friends: ['', '', '', ''],
    nemesis: '',
    brothers: ['', '', '', ''],
    sisters: ['', '', '', ''],
    mom: '',
    dad: '',
    aunt: '',
    uncle: '',
    grandpa: '',
    grandma: '',
    teacher: '',
    coach: '',
    themes: [],
    interests: [],
  });
  const [loading, setLoading] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [loadingContent, setLoadingContent] = useState(true);
  const [themesData, setThemesData] = useState([]);
  const [interestCategories, setInterestCategories] = useState([]);
  const [languagesData, setLanguagesData] = useState([]);
  const [tonesData, setTonesData] = useState([]);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [upgradeMessage, setUpgradeMessage] = useState('');

  const totalSteps = 9;

  // Fallback static theme data (used if API fails)
  const fallbackThemesData = [
    { value: 'adventure', emoji: '🗺️', title: 'Adventure', description: 'Exciting journeys and quests' },
    { value: 'fairy-tales', emoji: '🏰', title: 'Fairy Tales', description: 'Magical kingdoms and princesses' },
    { value: 'superheroes', emoji: '🦸', title: 'Superheroes', description: 'Save the day with superpowers' },
    { value: 'sci-fi', emoji: '🤖', title: 'Sci-Fi', description: 'Futuristic technology and robots' },
    { value: 'space-exploration', emoji: '🚀', title: 'Space Exploration', description: 'Journey to distant planets' },
    { value: 'time-travel', emoji: '⏰', title: 'Time Travel', description: 'Travel through past and future' },
    { value: 'fantasy', emoji: '🐉', title: 'Fantasy', description: 'Dragons, wizards, and magic' },
    { value: 'dinosaurs', emoji: '🦕', title: 'Dinosaurs', description: 'Prehistoric adventures' },
    { value: 'pirates', emoji: '🏴‍☠️', title: 'Pirates', description: 'Treasure hunts on the high seas' },
    { value: 'animals', emoji: '🦁', title: 'Animals', description: 'Adventures with animal friends' },
    { value: 'mythology', emoji: '⚡', title: 'Mythology', description: 'Gods, heroes, and legends' },
    { value: 'detective', emoji: '🕵️', title: 'Detective', description: 'Solve mysteries and crimes' },
    { value: 'sports', emoji: '⚽', title: 'Sports', description: 'Games, competitions, and teamwork' },
    { value: 'leader', emoji: '👑', title: 'Leader', description: 'Leadership and responsibility' },
    { value: 'underwater-world', emoji: '🐠', title: 'Underwater World', description: 'Ocean adventures and sea creatures' },
    { value: 'mystery', emoji: '🔍', title: 'Mystery', description: 'Solve puzzles and clues' },
    { value: 'music-arts', emoji: '🎵', title: 'Music and Arts', description: 'Creative expression and melodies' },
    { value: 'dancing', emoji: '💃', title: 'Dancing', description: 'Rhythm, movement, and joy' },
    { value: 'history', emoji: '📜', title: 'History', description: 'Stories from the past' },
    { value: 'environment', emoji: '🌍', title: 'Environment', description: 'Nature and conservation' },
    { value: 'great-student', emoji: '📚', title: 'Great Student', description: 'Learning and achievement' },
    { value: 'family', emoji: '👨‍👩‍👧‍👦', title: 'Family', description: 'Family bonds and togetherness' },
    { value: 'awesome-parents', emoji: '💕', title: 'Awesome Parents', description: 'Celebrating amazing parents' },
    { value: 'awesome-mom', emoji: '👩', title: 'Awesome Mom', description: 'Stories about wonderful mothers' },
    { value: 'awesome-dad', emoji: '👨', title: 'Awesome Dad', description: 'Stories about wonderful fathers' },
    { value: 'awesome-siblings', emoji: '👫', title: 'Awesome Siblings', description: 'Brother and sister adventures' },
    { value: 'awesome-brother', emoji: '👦', title: 'Awesome Brother', description: 'Stories about great brothers' },
    { value: 'awesome-sister', emoji: '👧', title: 'Awesome Sister', description: 'Stories about great sisters' },
    { value: 'cultural-celebrations', emoji: '🎉', title: 'Cultural Celebrations', description: 'Festivals and traditions' },
    { value: 'our-society', emoji: '🌐', title: 'Our Society', description: 'Community and social values' },
  ];

  // Fallback static interest categories (used if API fails)
  const fallbackInterestCategories = [
    {
      key: 'animals',
      emoji: '🐾',
      title: 'Animals',
      items: [
        { value: 'Dogs', label: 'Dogs' },
        { value: 'Cats', label: 'Cats' },
        { value: 'Dragon', label: 'Dragon' },
        { value: 'Unicorns', label: 'Unicorns' },
        { value: 'Birds', label: 'Birds' },
        { value: 'Marine Life', label: 'Marine Life' },
      ],
    },
    {
      key: 'science-tech',
      emoji: '🔬',
      title: 'Science & Tech',
      items: [
        { value: 'Robots', label: 'Robots' },
        { value: 'Space', label: 'Space' },
        { value: 'Inventions', label: 'Inventions' },
        { value: 'Computers', label: 'Computers' },
      ],
    },
    {
      key: 'arts-crafts',
      emoji: '🎨',
      title: 'Arts & Crafts',
      items: [
        { value: 'Painting', label: 'Painting' },
        { value: 'Drawing', label: 'Drawing' },
        { value: 'Sculpting', label: 'Sculpting' },
        { value: 'Photography', label: 'Photography' },
      ],
    },
    {
      key: 'music-dance',
      emoji: '🎵',
      title: 'Music & Dance',
      items: [
        { value: 'Singing', label: 'Singing' },
        { value: 'Instruments', label: 'Instruments' },
        { value: 'Ballet, Jazz Dance', label: 'Ballet / Jazz Dance' },
        { value: 'Hip-hop Dance', label: 'Hip-hop Dance' },
      ],
    },
    {
      key: 'sports',
      emoji: '⚽',
      title: 'Sports',
      items: [
        { value: 'Soccer', label: 'Soccer' },
        { value: 'Basketball', label: 'Basketball' },
        { value: 'Football', label: 'Football' },
        { value: 'Swimming', label: 'Swimming' },
        { value: 'Gymnastics', label: 'Gymnastics' },
        { value: 'Martial Arts', label: 'Martial Arts' },
      ],
    },
    {
      key: 'vehicles',
      emoji: '🚗',
      title: 'Vehicles',
      items: [
        { value: 'Cars', label: 'Cars' },
        { value: 'Airplanes', label: 'Airplanes' },
        { value: 'Trains', label: 'Trains' },
        { value: 'Ships', label: 'Ships' },
        { value: 'Bikes', label: 'Bikes' },
      ],
    },
    {
      key: 'careers',
      emoji: '💼',
      title: 'Careers',
      items: [
        { value: 'Doctor', label: 'Doctor' },
        { value: 'Teacher', label: 'Teacher' },
        { value: 'Engineer', label: 'Engineer' },
        { value: 'Scientists', label: 'Scientists' },
        { value: 'Artist', label: 'Artist' },
        { value: 'Inventor', label: 'Inventor' },
      ],
    },
    {
      key: 'culture',
      emoji: '🌍',
      title: 'Culture',
      items: [
        { value: 'New Languages', label: 'New Languages' },
        { value: 'Cultural Traditions', label: 'Cultural Traditions' },
        { value: 'World Travel', label: 'World Travel' },
        { value: 'Cultural Exchange', label: 'Cultural Exchange' },
      ],
    },
    {
      key: 'family',
      emoji: '👨‍👩‍👧‍👦',
      title: 'Family',
      items: [
        { value: 'Teamwork', label: 'Teamwork' },
        { value: 'Family Adventures', label: 'Family Adventures' },
        { value: 'Family Bonds', label: 'Family Bonds' },
      ],
    },
    {
      key: 'holidays',
      emoji: '🎉',
      title: 'Holidays',
      items: [
        { value: 'Christmas', label: 'Christmas' },
        { value: 'Eid', label: 'Eid' },
        { value: 'Hanukkah', label: 'Hanukkah' },
        { value: 'Birthdays', label: 'Birthdays' },
        { value: 'Halloween', label: 'Halloween' },
        { value: 'Diwali', label: 'Diwali' },
        { value: 'Easter', label: 'Easter' },
      ],
    },
  ];

  // Fallback static language data (used if API fails)
  const fallbackLanguagesData = [
    { value: 'english', emoji: '🇺🇸', title: 'English', description: 'Default language', recommended: true },
    { value: 'spanish', emoji: '🇪🇸', title: 'Spanish', description: 'Español' },
    { value: 'french', emoji: '🇫🇷', title: 'French', description: 'Français' },
    { value: 'german', emoji: '🇩🇪', title: 'German', description: 'Deutsch' },
    { value: 'italian', emoji: '🇮🇹', title: 'Italian', description: 'Italiano' },
    { value: 'portuguese', emoji: '🇵🇹', title: 'Portuguese', description: 'Português' },
    { value: 'dutch', emoji: '🇳🇱', title: 'Dutch', description: 'Nederlands' },
    { value: 'swedish', emoji: '🇸🇪', title: 'Swedish', description: 'Svenska' },
    { value: 'norwegian', emoji: '🇳🇴', title: 'Norwegian', description: 'Norsk' },
    { value: 'danish', emoji: '🇩🇰', title: 'Danish', description: 'Dansk' },
    { value: 'finnish', emoji: '🇫🇮', title: 'Finnish', description: 'Suomi' },
    { value: 'polish', emoji: '🇵🇱', title: 'Polish', description: 'Polski' },
    { value: 'czech', emoji: '🇨🇿', title: 'Czech', description: 'Čeština' },
    { value: 'russian', emoji: '🇷🇺', title: 'Russian', description: 'Русский' },
    { value: 'chinese-simplified', emoji: '🇨🇳', title: 'Chinese (Simplified)', description: '简体中文' },
    { value: 'japanese', emoji: '🇯🇵', title: 'Japanese', description: '日本語' },
    { value: 'korean', emoji: '🇰🇷', title: 'Korean', description: '한국어' },
    { value: 'arabic', emoji: '🇸🇦', title: 'Arabic', description: 'العربية' },
    { value: 'hindi', emoji: '🇮🇳', title: 'Hindi', description: 'हिन्दी' },
    { value: 'bengali', emoji: '🇧🇩', title: 'Bengali', description: 'বাংলা' },
    { value: 'urdu', emoji: '🇵🇰', title: 'Urdu', description: 'اردو' },
    { value: 'turkish', emoji: '🇹🇷', title: 'Turkish', description: 'Türkçe' },
    { value: 'greek', emoji: '🇬🇷', title: 'Greek', description: 'Ελληνικά' },
    { value: 'gujarati', emoji: '🇮🇳', title: 'Gujarati', description: 'ગુજરાતી' },
    { value: 'punjabi', emoji: '🇮🇳', title: 'Punjabi', description: 'ਪੰਜਾਬੀ' },
    { value: 'swahili', emoji: '🇹🇿', title: 'Swahili', description: 'Kiswahili' },
    { value: 'zulu', emoji: '🇿🇦', title: 'Zulu', description: 'isiZulu' },
    { value: 'hungarian', emoji: '🇭🇺', title: 'Hungarian', description: 'Magyar' },
    { value: 'romanian', emoji: '🇷🇴', title: 'Romanian', description: 'Română' },
    { value: 'bulgarian', emoji: '🇧🇬', title: 'Bulgarian', description: 'Български' },
    { value: 'ukrainian', emoji: '🇺🇦', title: 'Ukrainian', description: 'Українська' },
    { value: 'indonesian', emoji: '🇮🇩', title: 'Indonesian', description: 'Bahasa Indonesia' },
    { value: 'thai', emoji: '🇹🇭', title: 'Thai', description: 'ไทย' },
    { value: 'malay', emoji: '🇲🇾', title: 'Malay', description: 'Bahasa Melayu' },
    { value: 'persian', emoji: '🇮🇷', title: 'Persian', description: 'فارسی' },
    { value: 'tagalog', emoji: '🇵🇭', title: 'Tagalog (Filipino)', description: 'Filipino' },
    { value: 'tamil', emoji: '🇮🇳', title: 'Tamil', description: 'தமிழ்' },
    { value: 'telugu', emoji: '🇮🇳', title: 'Telugu', description: 'తెలుగు' },
    { value: 'marathi', emoji: '🇮🇳', title: 'Marathi', description: 'मराठी' },
    { value: 'kannada', emoji: '🇮🇳', title: 'Kannada', description: 'ಕನ್ನಡ' },
    { value: 'malayalam', emoji: '🇮🇳', title: 'Malayalam', description: 'മലയാളം' },
    { value: 'catalan', emoji: '🇪🇸', title: 'Catalan', description: 'Català' },
    { value: 'slovak', emoji: '🇸🇰', title: 'Slovak', description: 'Slovenčina' },
    { value: 'croatian', emoji: '🇭🇷', title: 'Croatian', description: 'Hrvatski' },
    { value: 'serbian', emoji: '🇷🇸', title: 'Serbian', description: 'Српски' },
    { value: 'slovenian', emoji: '🇸🇮', title: 'Slovenian', description: 'Slovenščina' },
    { value: 'lithuanian', emoji: '🇱🇹', title: 'Lithuanian', description: 'Lietuvių' },
    { value: 'latvian', emoji: '🇱🇻', title: 'Latvian', description: 'Latviešu' },
    { value: 'estonian', emoji: '🇪🇪', title: 'Estonian', description: 'Eesti' },
  ];

  // Fallback static tone data (used if API fails)
  const fallbackTonesData = [
    { value: 'entertaining', emoji: '🎭', title: 'Entertaining', description: 'Fun and engaging stories that captivate' },
    { value: 'humorous', emoji: '😄', title: 'Humorous', description: 'Funny stories full of laughter and jokes' },
    { value: 'adventurous', emoji: '⚡', title: 'Adventurous', description: 'Exciting tales of exploration and discovery' },
    { value: 'inspirational', emoji: '✨', title: 'Inspirational', description: 'Uplifting stories that motivate and inspire' },
    { value: 'educational', emoji: '📚', title: 'Educational', description: 'Learning through storytelling and discovery' },
  ];

  // Fetch dynamic content on component mount
  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoadingContent(true);
        const [themesRes, interestsRes, languagesRes, tonesRes] = await Promise.all([
          api.get('/themes').catch(() => ({ data: { success: false } })),
          api.get('/interest-categories').catch(() => ({ data: { success: false } })),
          api.get('/languages').catch(() => ({ data: { success: false } })),
          api.get('/tones').catch(() => ({ data: { success: false } }))
        ]);

        // Transform themes data
        if (themesRes.data.success && themesRes.data.themes?.length > 0) {
          setThemesData(themesRes.data.themes.map(t => ({
            value: t.value,
            emoji: t.emoji || '',
            title: t.name,
            description: t.description || ''
          })));
        } else {
          setThemesData(fallbackThemesData);
        }

        // Transform interest categories data
        if (interestsRes.data.success && interestsRes.data.categories?.length > 0) {
          setInterestCategories(interestsRes.data.categories.map(cat => ({
            key: cat.key_name,
            emoji: cat.emoji || '',
            title: cat.name,
            items: cat.items || []
          })));
        } else {
          setInterestCategories(fallbackInterestCategories);
        }

        // Transform languages data
        if (languagesRes.data.success && languagesRes.data.languages?.length > 0) {
          setLanguagesData(languagesRes.data.languages.map(lang => ({
            value: lang.code,
            emoji: lang.emoji || '',
            title: lang.name,
            description: lang.description || '',
            recommended: lang.is_recommended || false
          })));
        } else {
          setLanguagesData(fallbackLanguagesData);
        }

        // Transform tones data
        if (tonesRes.data.success && tonesRes.data.tones?.length > 0) {
          setTonesData(tonesRes.data.tones.map(tone => ({
            value: tone.value,
            emoji: tone.emoji || '',
            title: tone.name,
            description: tone.description || ''
          })));
        } else {
          setTonesData(fallbackTonesData);
        }
      } catch (error) {
        console.error('Error fetching content:', error);
        // Use fallback data on error
        setThemesData(fallbackThemesData);
        setInterestCategories(fallbackInterestCategories);
        setLanguagesData(fallbackLanguagesData);
        setTonesData(fallbackTonesData);
      } finally {
        setLoadingContent(false);
      }
    };

    fetchContent();
    // Fallback data is static and intentionally not included to avoid re-fetch loops.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Ending options
  const endingsData = [
    { value: 'happy', emoji: '😊', title: 'Happy', description: 'Stories end with joy, success, and satisfaction', default: true },
    { value: 'open-ended', emoji: '🤔', title: 'Open-ended', description: 'Stories that leave room for imagination and discussion' },
    { value: 'surprise-twist', emoji: '🎉', title: 'Surprise Twist', description: 'Unexpected endings that surprise and delight' },
  ];

  // Voice options
  const voicesData = [
    { value: 'male', emoji: '👨', title: 'Male Voice', description: 'Warm, friendly male narrator', default: true },
    { value: 'female', emoji: '👩', title: 'Female Voice', description: 'Gentle, caring female narrator' },
  ];

  // Speed options
  const speedsData = [
    { value: 'slower', emoji: '🐢', title: 'Slower', speed: '0.75x speed', description: 'Perfect for younger children or learning' },
    { value: 'normal', emoji: '🚶', title: 'Normal', speed: '1x speed', description: 'Standard reading pace for most children', default: true },
    { value: 'faster', emoji: '🏃', title: 'Faster', speed: '1.25x speed', description: 'For advanced readers or shorter attention spans' },
  ];

  // Load firstName from URL params if provided (for unauthenticated users)
  useEffect(() => {
    const firstNameParam = searchParams.get('firstName');
    if (firstNameParam && !id && !formData.firstName) {
      setFormData(prev => ({ ...prev, firstName: decodeURIComponent(firstNameParam) }));
    }
  }, [searchParams, id]);

  useEffect(() => {
    if (id) {
      // Load existing profile data if editing
      const loadProfile = async () => {
        setLoadingProfile(true);
        try {
          const response = await api.get(`/profiles/${id}`);
          if (response.data.success) {
            const profile = response.data.profile;
            
            // Transform characters array into grouped format
            const characters = profile.characters || [];
            const friends = characters
              .filter(c => c.character_type === 'friend')
              .map(c => c.name);
            const brothers = characters
              .filter(c => c.character_type === 'brother')
              .map(c => c.name);
            const sisters = characters
              .filter(c => c.character_type === 'sister')
              .map(c => c.name);
            
            // Get single character fields
            const getCharacter = (type) => {
              const char = characters.find(c => c.character_type === type);
              return char ? char.name : '';
            };
            
            // Format date for date input (YYYY-MM-DD)
            const formatDate = (dateString) => {
              if (!dateString) return '';
              const date = new Date(dateString);
              if (isNaN(date.getTime())) return '';
              return date.toISOString().split('T')[0];
            };
            
            setFormData({
              // Map snake_case to camelCase
              firstName: profile.first_name || '',
              lastName: profile.last_name || '',
              gender: profile.gender || '',
              dateOfBirth: formatDate(profile.date_of_birth),
              age: profile.age?.toString() || '',
              ethnicity: profile.ethnicity || '',
              country: profile.country || '',
              language: profile.language || 'english',
              tone: profile.tone || 'entertaining',
              ending: profile.ending || 'happy',
              voice: profile.voice || 'male',
              readingSpeed: profile.reading_speed || 'normal',
              
              // Transform characters arrays
              friends: friends.length > 0 ? [...friends, '', '', ''].slice(0, 4) : ['', '', '', ''],
              nemesis: getCharacter('nemesis'),
              brothers: brothers.length > 0 ? [...brothers, '', '', ''].slice(0, 4) : ['', '', '', ''],
              sisters: sisters.length > 0 ? [...sisters, '', '', ''].slice(0, 4) : ['', '', '', ''],
              mom: getCharacter('mom'),
              dad: getCharacter('dad'),
              aunt: getCharacter('aunt'),
              uncle: getCharacter('uncle'),
              grandpa: getCharacter('grandpa'),
              grandma: getCharacter('grandma'),
              teacher: getCharacter('teacher'),
              coach: getCharacter('coach'),
              
              // Themes and interests are already arrays
              themes: profile.themes || [],
              interests: profile.interests || [],
            });
          }
        } catch (error) {
          console.error('Error loading profile:', error);
          toast.error('Failed to load profile');
        } finally {
          setLoadingProfile(false);
        }
      };
      loadProfile();
    }
  }, [id]);

  const updateFormData = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const updateArrayField = (field, index, value) => {
    setFormData((prev) => {
      const newArray = [...prev[field]];
      newArray[index] = value;
      return { ...prev, [field]: newArray };
    });
  };

  const toggleArrayItem = (field, value) => {
    setFormData((prev) => {
      const arr = prev[field] || [];
      if (arr.includes(value)) {
        return { ...prev, [field]: arr.filter((item) => item !== value) };
      } else {
        return { ...prev, [field]: [...arr, value] };
      }
    });
  };

  const selectSingle = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateStep = () => {
    switch (currentStep) {
      case 1:
        return formData.firstName && formData.gender && formData.age && formData.country;
      case 3:
        return formData.themes.length > 0;
      case 4:
        return formData.interests.length > 0;
      default:
        return true;
    }
  };

  const handleNext = () => {
    if (validateStep()) {
      if (currentStep < totalSteps) {
        setCurrentStep(currentStep + 1);
      } else {
        handleSubmit();
      }
    } else {
      toast.error('Please complete all required fields');
    }
  };

  const handlePrev = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = async () => {
    // Check if user is authenticated
    if (!isAuthenticated) {
      // Save profile data to localStorage and redirect to register
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        gender: formData.gender,
        dateOfBirth: formData.dateOfBirth || null,
        age: parseInt(formData.age),
        ethnicity: formData.ethnicity || null,
        country: formData.country,
        language: formData.language,
        tone: formData.tone,
        ending: formData.ending,
        voice: formData.voice,
        readingSpeed: formData.readingSpeed,
        friends: formData.friends.filter((f) => f.trim()),
        nemesis: formData.nemesis || null,
        brothers: formData.brothers.filter((b) => b.trim()),
        sisters: formData.sisters.filter((s) => s.trim()),
        mom: formData.mom || null,
        dad: formData.dad || null,
        aunt: formData.aunt || null,
        uncle: formData.uncle || null,
        grandpa: formData.grandpa || null,
        grandma: formData.grandma || null,
        teacher: formData.teacher || null,
        coach: formData.coach || null,
        themes: formData.themes,
        interests: formData.interests,
      };
      
      localStorage.setItem('pendingProfile', JSON.stringify(payload));
      toast.success('Please sign up to save your profile');
      navigate('/register');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        gender: formData.gender,
        dateOfBirth: formData.dateOfBirth || null,
        age: parseInt(formData.age),
        ethnicity: formData.ethnicity || null,
        country: formData.country,
        language: formData.language,
        tone: formData.tone,
        ending: formData.ending,
        voice: formData.voice,
        readingSpeed: formData.readingSpeed,
        friends: formData.friends.filter((f) => f.trim()),
        nemesis: formData.nemesis || null,
        brothers: formData.brothers.filter((b) => b.trim()),
        sisters: formData.sisters.filter((s) => s.trim()),
        mom: formData.mom || null,
        dad: formData.dad || null,
        aunt: formData.aunt || null,
        uncle: formData.uncle || null,
        grandpa: formData.grandpa || null,
        grandma: formData.grandma || null,
        teacher: formData.teacher || null,
        coach: formData.coach || null,
        themes: formData.themes,
        interests: formData.interests,
      };

      const response = id
        ? await api.put(`/profiles/${id}`, payload)
        : await api.post('/profiles', payload);

      if (response.data.success) {
        toast.success('Profile saved successfully!');
        navigate('/profiles');
      }
    } catch (error) {
      // Check if upgrade is required
      if (error.response?.status === 403 && error.response?.data?.requiresUpgrade) {
        setUpgradeMessage(error.response.data.message || 'Please upgrade to create more profiles.');
        setShowUpgradeModal(true);
        setLoading(false);
        return;
      }
      
      const errorMessage = error.response?.data?.message || 'Failed to save profile';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const progress = (currentStep / totalSteps) * 100;

  if (loadingProfile) {
    return null;
  }

  // Show loading while fetching dynamic content
  if (loadingContent) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-purple-100 flex flex-col">
        <Header />
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading content...</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-purple-100 flex flex-col">
      <Header />
      <div className="container mx-auto px-4 py-8 max-w-5xl flex-1">
        <div className="text-center mb-8">
          <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
            {id ? 'Edit' : 'Create'} Your Child's{' '}
            <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              Story Profile
            </span>
          </h1>
          <p className="text-gray-600 text-lg">Build a magical character profile in {totalSteps} easy steps</p>
        </div>

        <div className="mb-8">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-gray-600">Progress</span>
            <span className="text-sm font-medium text-purple-600">
              Step {currentStep} of {totalSteps}
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-gradient-to-r from-purple-600 to-pink-600 h-2 rounded-full transition-all duration-500"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-6 lg:p-8 relative overflow-hidden">
          {/* Floating decorative elements */}
          <div className="absolute top-4 right-4 text-purple-200 animate-pulse">
            <Sparkles className="h-8 w-8" />
          </div>

          {/* Step 1: Child Details */}
          {currentStep === 1 && (
            <div className="animate-fade-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-purple-600 rounded-full mx-auto flex items-center justify-center text-white mb-4 shadow-lg">
                  <User className="h-8 w-8" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Child Details</h2>
                <p className="text-gray-600">Let's start with the basic information about your child</p>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {/* Left Column */}
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">First Name *</label>
                      <input
                        type="text"
                        value={formData.firstName}
                        onChange={(e) => updateFormData('firstName', e.target.value)}
                        placeholder="Enter first name"
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none text-lg font-medium transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
                      <input
                        type="text"
                        value={formData.lastName}
                        onChange={(e) => updateFormData('lastName', e.target.value)}
                        placeholder="Enter last name"
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none text-lg transition-colors"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Gender *</label>
                    <select
                      value={formData.gender}
                      onChange={(e) => updateFormData('gender', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none text-lg transition-colors"
                      required
                    >
                      <option value="">Select gender...</option>
                      <option value="boy">Boy</option>
                      <option value="girl">Girl</option>
                      <option value="non-binary">Non-binary</option>
                      <option value="prefer-not-to-say">Prefer not to say</option>
                    </select>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Age *</label>
                      <select
                        value={formData.age}
                        onChange={(e) => updateFormData('age', e.target.value)}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none text-lg transition-colors"
                        required
                      >
                        <option value="">Select age...</option>
                        <option value="2">2 years old</option>
                        <option value="3">3 years old</option>
                        <option value="4">4 years old</option>
                        <option value="5">5 years old</option>
                        <option value="6">6 years old</option>
                        <option value="7">7 years old</option>
                        <option value="8">8 years old</option>
                        <option value="9">9 years old</option>
                        <option value="10">10+ years old</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Date of Birth</label>
                      <input
                        type="date"
                        value={formData.dateOfBirth}
                        onChange={(e) => updateFormData('dateOfBirth', e.target.value)}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none text-lg transition-colors"
                      />
                    </div>
                  </div>
                </div>

                {/* Right Column */}
                <div className="space-y-4">

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Ethnicity</label>
                    <select
                      value={formData.ethnicity}
                      onChange={(e) => updateFormData('ethnicity', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none text-lg transition-colors"
                    >
                      <option value="">Select ethnicity...</option>
                      <option value="african-american">African American</option>
                      <option value="asian">Asian</option>
                      <option value="caucasian">Caucasian</option>
                      <option value="hispanic-latino">Hispanic/Latino</option>
                      <option value="middle-eastern">Middle Eastern</option>
                      <option value="native-american">Native American</option>
                      <option value="pacific-islander">Pacific Islander</option>
                      <option value="mixed">Mixed</option>
                      <option value="other">Other</option>
                      <option value="prefer-not-to-say">Prefer not to say</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Country *</label>
                    <select
                      value={formData.country}
                      onChange={(e) => updateFormData('country', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none text-lg transition-colors"
                      required
                    >
                      <option value="">Select country...</option>
                      {COUNTRIES.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Quick Tips */}
                  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4">
                    <div className="flex items-start gap-2">
                      <Lightbulb className="h-5 w-5 text-blue-600 mt-0.5" />
                      <div>
                        <h4 className="font-semibold text-blue-900 text-sm mb-1">💡 Pro Tip</h4>
                        <p className="text-blue-700 text-xs">Required fields (*) help us create age-appropriate and culturally relevant stories for your child.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 2: Story Characters */}
          {currentStep === 2 && (
            <div className="animate-fade-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full mx-auto flex items-center justify-center text-white mb-4 shadow-lg">
                  <Users className="h-8 w-8" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Story Characters</h2>
                <p className="text-gray-600">
                  Add people who can appear in <span className="font-semibold text-purple-600">{formData.firstName || 'your child'}</span>'s stories (Optional)
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {/* Left Column - Friends & Nemesis & Siblings */}
                <div className="space-y-6">
                  {/* Friends */}
                  <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <Heart className="h-5 w-5 text-green-600" />
                      Friends (Maximum 4)
                    </h3>
                    <div className="space-y-3">
                      {[0, 1, 2, 3].map((index) => (
                        <input
                          key={index}
                          type="text"
                          value={formData.friends[index] || ''}
                          onChange={(e) => updateArrayField('friends', index, e.target.value)}
                          placeholder={`Friend ${index + 1} name`}
                          className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-green-500 focus:outline-none transition-colors"
                        />
                      ))}
                    </div>
                  </div>

                  {/* Nemesis */}
                  <div className="bg-gradient-to-r from-red-50 to-rose-50 rounded-xl p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <Zap className="h-5 w-5 text-red-600" />
                      Nemesis/Rival
                    </h3>
                    <input
                      type="text"
                      value={formData.nemesis}
                      onChange={(e) => updateFormData('nemesis', e.target.value)}
                      placeholder="Nemesis name (optional)"
                      className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-red-500 focus:outline-none transition-colors"
                    />
                  </div>

                  {/* Siblings */}
                  <div className="bg-gradient-to-r from-purple-50 to-violet-50 rounded-xl p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <Users className="h-5 w-5 text-purple-600" />
                      Siblings
                    </h3>
                    <div className="space-y-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Brothers (Maximum 4)</label>
                        <div className="space-y-2">
                          {[0, 1, 2, 3].map((index) => (
                            <input
                              key={index}
                              type="text"
                              value={formData.brothers[index] || ''}
                              onChange={(e) => updateArrayField('brothers', index, e.target.value)}
                              placeholder={`Brother ${index + 1} name`}
                              className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none transition-colors"
                            />
                          ))}
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Sisters (Maximum 4)</label>
                        <div className="space-y-2">
                          {[0, 1, 2, 3].map((index) => (
                            <input
                              key={index}
                              type="text"
                              value={formData.sisters[index] || ''}
                              onChange={(e) => updateArrayField('sisters', index, e.target.value)}
                              placeholder={`Sister ${index + 1} name`}
                              className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none transition-colors"
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column - Family & Others */}
                <div className="space-y-6">
                  {/* Parents */}
                  <div className="bg-gradient-to-r from-pink-50 to-rose-50 rounded-xl p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <Home className="h-5 w-5 text-pink-600" />
                      Parents
                    </h3>
                    <div className="space-y-3">
                      <input
                        type="text"
                        value={formData.mom}
                        onChange={(e) => updateFormData('mom', e.target.value)}
                        placeholder="Mom's name"
                        className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-pink-500 focus:outline-none transition-colors"
                      />
                      <input
                        type="text"
                        value={formData.dad}
                        onChange={(e) => updateFormData('dad', e.target.value)}
                        placeholder="Dad's name"
                        className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-pink-500 focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  {/* Extended Family */}
                  <div className="bg-gradient-to-r from-yellow-50 to-amber-50 rounded-xl p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <Users2 className="h-5 w-5 text-yellow-600" />
                      Extended Family
                    </h3>
                    <div className="space-y-3">
                      <input
                        type="text"
                        value={formData.aunt}
                        onChange={(e) => updateFormData('aunt', e.target.value)}
                        placeholder="Aunt's name"
                        className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-yellow-500 focus:outline-none transition-colors"
                      />
                      <input
                        type="text"
                        value={formData.uncle}
                        onChange={(e) => updateFormData('uncle', e.target.value)}
                        placeholder="Uncle's name"
                        className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-yellow-500 focus:outline-none transition-colors"
                      />
                      <input
                        type="text"
                        value={formData.grandpa}
                        onChange={(e) => updateFormData('grandpa', e.target.value)}
                        placeholder="Grandpa's name"
                        className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-yellow-500 focus:outline-none transition-colors"
                      />
                      <input
                        type="text"
                        value={formData.grandma}
                        onChange={(e) => updateFormData('grandma', e.target.value)}
                        placeholder="Grandma's name"
                        className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-yellow-500 focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  {/* Other Important People */}
                  <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-xl p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <GraduationCap className="h-5 w-5 text-indigo-600" />
                      Other Important People
                    </h3>
                    <div className="space-y-3">
                      <input
                        type="text"
                        value={formData.teacher}
                        onChange={(e) => updateFormData('teacher', e.target.value)}
                        placeholder="Teacher's name"
                        className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-indigo-500 focus:outline-none transition-colors"
                      />
                      <input
                        type="text"
                        value={formData.coach}
                        onChange={(e) => updateFormData('coach', e.target.value)}
                        placeholder="Coach's name"
                        className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-indigo-500 focus:outline-none transition-colors"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 3: Story Themes */}
          {currentStep === 3 && (
            <div className="animate-fade-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-full mx-auto flex items-center justify-center text-white mb-4 shadow-lg">
                  <BookOpen className="h-8 w-8" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Select Story Themes</h2>
                <p className="text-gray-600">
                  Select Story Themes from the following list – <span className="font-semibold text-red-500">Required*</span>
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {themesData.map((theme) => (
                  <div
                    key={theme.value}
                    onClick={() => toggleArrayItem('themes', theme.value)}
                    className={`border-2 rounded-xl p-4 text-center cursor-pointer transition-all hover:transform hover:-translate-y-1 ${
                      formData.themes.includes(theme.value)
                        ? 'border-purple-600 bg-gradient-to-br from-purple-50 to-pink-50 shadow-lg transform -translate-y-1'
                        : 'border-gray-200 hover:border-purple-300 hover:shadow-md'
                    }`}
                  >
                    <div className="text-4xl mb-2">{theme.emoji}</div>
                    <h3 className="font-semibold text-gray-900">{theme.title}</h3>
                    <p className="text-xs text-gray-600 mt-1">{theme.description}</p>
                  </div>
                ))}
              </div>

              <div className="mt-6 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-4">
                <p className="text-sm text-purple-700 text-center">
                  <Info className="h-4 w-4 mr-1 inline" />
                  Select at least one theme to continue. You can choose multiple themes!
                </p>
              </div>
            </div>
          )}

          {/* Step 4: Interests */}
          {currentStep === 4 && (
            <div className="animate-fade-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-pink-600 rounded-full mx-auto flex items-center justify-center text-white mb-4 shadow-lg">
                  <Heart className="h-8 w-8" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Select Interests</h2>
                <p className="text-gray-600">
                  Select interests from the categorized tables below – <span className="font-semibold text-red-500">Required*</span>
                </p>
              </div>

              <div className="space-y-6">
                {interestCategories.map((category) => (
                  <div
                    key={category.key}
                    className="bg-white border border-pink-100 rounded-2xl p-5 shadow-sm"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-3">
                        <span className="text-3xl">{category.emoji}</span>
                        <h3 className="text-lg font-semibold text-gray-900">{category.title}</h3>
                      </div>
                      <p className="text-sm text-gray-500">
                        Choose interests that fit {formData.firstName || 'your child'}
                      </p>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                      {category.items.map((item) => (
                        <button
                          type="button"
                          key={item.value}
                          onClick={() => toggleArrayItem('interests', item.value)}
                          className={`px-4 py-3 rounded-xl border-2 text-sm font-medium transition-all text-left ${
                            formData.interests.includes(item.value)
                              ? 'border-pink-500 bg-pink-50 text-pink-700 shadow-md'
                              : 'border-gray-200 text-gray-700 hover:border-pink-300 hover:bg-pink-50'
                          }`}
                        >
                          {item.label}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-6 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-4">
                <p className="text-sm text-purple-700 text-center">
                  <Info className="h-4 w-4 mr-1 inline" />
                  Select at least one interest to continue. Multiple selections help create richer stories!
                </p>
              </div>
            </div>
          )}

          {/* Step 5: Story Language */}
          {currentStep === 5 && (
            <div className="animate-fade-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-full mx-auto flex items-center justify-center text-white mb-4 shadow-lg">
                  <Globe className="h-8 w-8" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Story Language</h2>
                <p className="text-gray-600">
                  Choose the language for <span className="font-semibold text-purple-600">{formData.firstName || 'your child'}</span>'s stories
                </p>
              </div>

              <div className="max-h-[600px] overflow-y-auto px-2">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 max-w-6xl mx-auto">
                  {languagesData.map((lang) => (
                    <div
                      key={lang.value}
                      onClick={() => selectSingle('language', lang.value)}
                      className={`border-2 rounded-xl p-4 text-center cursor-pointer transition-all hover:transform hover:-translate-y-1 ${
                        formData.language === lang.value
                          ? 'border-purple-600 bg-gradient-to-br from-purple-50 to-pink-50 shadow-lg transform -translate-y-1'
                          : 'border-gray-200 hover:border-purple-300 hover:shadow-md'
                      }`}
                    >
                      <div className="text-3xl mb-2">{lang.emoji}</div>
                      <h3 className="font-semibold text-gray-900 text-sm md:text-base">{lang.title}</h3>
                      <p className="text-xs text-gray-600 mt-1">{lang.description}</p>
                      {lang.recommended && (
                        <div className="mt-2">
                          <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">Default</span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4">
                <p className="text-sm text-blue-700 text-center">
                  <Info className="h-4 w-4 mr-1 inline" />
                  English will be selected by default if no language is chosen
                </p>
              </div>
            </div>
          )}

          {/* Step 6: Story Tone */}
          {currentStep === 6 && (
            <div className="animate-fade-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-full mx-auto flex items-center justify-center text-white mb-4 shadow-lg">
                  <Smile className="h-8 w-8" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Story Tone</h2>
                <p className="text-gray-600">
                  What mood should <span className="font-semibold text-purple-600">{formData.firstName || 'your child'}</span>'s stories have?
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
                {tonesData.map((tone) => (
                  <div
                    key={tone.value}
                    onClick={() => selectSingle('tone', tone.value)}
                    className={`border-2 rounded-xl p-6 text-center cursor-pointer transition-all hover:transform hover:-translate-y-1 ${
                      formData.tone === tone.value
                        ? 'border-purple-600 bg-gradient-to-br from-purple-50 to-pink-50 shadow-lg transform -translate-y-1'
                        : 'border-gray-200 hover:border-purple-300 hover:shadow-md'
                    }`}
                  >
                    <div className="text-4xl mb-3">{tone.emoji}</div>
                    <h3 className="font-semibold text-gray-900 text-lg">{tone.title}</h3>
                    <p className="text-sm text-gray-600 mt-2">{tone.description}</p>
                  </div>
                ))}
              </div>

              <div className="mt-6 bg-gradient-to-r from-yellow-50 to-amber-50 rounded-lg p-4">
                <p className="text-sm text-yellow-700 text-center">
                  <Info className="h-4 w-4 mr-1 inline" />
                  This is optional - we'll create entertaining stories by default
                </p>
              </div>
            </div>
          )}

          {/* Step 7: Story Ending */}
          {currentStep === 7 && (
            <div className="animate-fade-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full mx-auto flex items-center justify-center text-white mb-4 shadow-lg">
                  <Flag className="h-8 w-8" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Story Ending</h2>
                <p className="text-gray-600">
                  How should <span className="font-semibold text-purple-600">{formData.firstName || 'your child'}</span>'s stories end?
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
                {endingsData.map((ending) => (
                  <div
                    key={ending.value}
                    onClick={() => selectSingle('ending', ending.value)}
                    className={`border-2 rounded-xl p-6 text-center cursor-pointer transition-all hover:transform hover:-translate-y-1 ${
                      formData.ending === ending.value
                        ? 'border-purple-600 bg-gradient-to-br from-purple-50 to-pink-50 shadow-lg transform -translate-y-1'
                        : 'border-gray-200 hover:border-purple-300 hover:shadow-md'
                    }`}
                  >
                    <div className="text-5xl mb-4">{ending.emoji}</div>
                    <h3 className="font-semibold text-gray-900 text-lg mb-2">{ending.title}</h3>
                    <p className="text-sm text-gray-600">{ending.description}</p>
                    {ending.default && (
                      <div className="mt-3">
                        <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">Default</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="mt-6 bg-gradient-to-r from-emerald-50 to-green-50 rounded-lg p-4">
                <p className="text-sm text-emerald-700 text-center">
                  <Info className="h-4 w-4 mr-1 inline" />
                  Happy endings will be used by default if no preference is selected
                </p>
              </div>
            </div>
          )}

          {/* Step 8: Story Voice */}
          {currentStep === 8 && (
            <div className="animate-fade-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-purple-600 rounded-full mx-auto flex items-center justify-center text-white mb-4 shadow-lg">
                  <Mic className="h-8 w-8" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Story Voice</h2>
                <p className="text-gray-600">
                  Choose the narrator voice for <span className="font-semibold text-purple-600">{formData.firstName || 'your child'}</span>'s stories
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto">
                {voicesData.map((voice) => (
                  <div
                    key={voice.value}
                    onClick={() => selectSingle('voice', voice.value)}
                    className={`border-2 rounded-xl p-8 text-center cursor-pointer transition-all hover:transform hover:-translate-y-1 ${
                      formData.voice === voice.value
                        ? 'border-purple-600 bg-gradient-to-br from-purple-50 to-pink-50 shadow-lg transform -translate-y-1'
                        : 'border-gray-200 hover:border-purple-300 hover:shadow-md'
                    }`}
                  >
                    <div className="text-6xl mb-4">{voice.emoji}</div>
                    <h3 className="font-semibold text-gray-900 text-xl mb-2">{voice.title}</h3>
                    <p className="text-sm text-gray-600">{voice.description}</p>
                    {voice.default && (
                      <div className="mt-4">
                        <span className="inline-block bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full">Default</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="mt-6 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-4">
                <p className="text-sm text-purple-700 text-center">
                  <Info className="h-4 w-4 mr-1 inline" />
                  Male voice will be used by default if no preference is selected
                </p>
              </div>
            </div>
          )}

          {/* Step 9: Reading Speed */}
          {currentStep === 9 && (
            <div className="animate-fade-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-cyan-500 to-cyan-600 rounded-full mx-auto flex items-center justify-center text-white mb-4 shadow-lg">
                  <Gauge className="h-8 w-8" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Reading Speed</h2>
                <p className="text-gray-600">
                  How fast should stories be read to <span className="font-semibold text-purple-600">{formData.firstName || 'your child'}</span>?
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
                {speedsData.map((speed) => (
                  <div
                    key={speed.value}
                    onClick={() => selectSingle('readingSpeed', speed.value)}
                    className={`border-2 rounded-xl p-6 text-center cursor-pointer transition-all hover:transform hover:-translate-y-1 ${
                      formData.readingSpeed === speed.value
                        ? 'border-purple-600 bg-gradient-to-br from-purple-50 to-pink-50 shadow-lg transform -translate-y-1'
                        : 'border-gray-200 hover:border-purple-300 hover:shadow-md'
                    }`}
                  >
                    <div className="text-5xl mb-4">{speed.emoji}</div>
                    <h3 className="font-semibold text-gray-900 text-lg mb-2">{speed.title}</h3>
                    <p className="text-sm text-gray-600 mb-2">{speed.speed}</p>
                    <p className="text-xs text-gray-500">{speed.description}</p>
                    {speed.default && (
                      <div className="mt-3">
                        <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">Default</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="mt-6 bg-gradient-to-r from-cyan-50 to-blue-50 rounded-lg p-4">
                <p className="text-sm text-cyan-700 text-center">
                  <Info className="h-4 w-4 mr-1 inline" />
                  Normal speed (1x) will be used by default if no preference is selected
                </p>
              </div>
            </div>
          )}

          {/* Navigation */}
          <div className="flex justify-between items-center mt-8 pt-6 border-t border-gray-200">
            <button
              onClick={handlePrev}
              disabled={currentStep === 1}
              className={`px-6 py-3 text-gray-600 hover:text-gray-800 font-medium transition-colors ${
                currentStep === 1 ? 'invisible' : ''
              } disabled:opacity-50 disabled:cursor-not-allowed`}
            >
              <ArrowLeft className="h-4 w-4 mr-2 inline" />
              Previous
            </button>
            <div className="flex-1"></div>
            <button
              onClick={handleNext}
              disabled={loading || !validateStep()}
              className="px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            >
              {currentStep === totalSteps ? (
                <>
                  <Check className="h-4 w-4 mr-2 inline" />
                  Create Profile
                </>
              ) : (
                <>
                  Continue
                  <ArrowRight className="h-4 w-4 ml-2 inline" />
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      <Footer />
      <UpgradeModal
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        message={upgradeMessage}
        reason="FREE_ACCOUNT_LIMIT"
      />
    </div>
  );
};

export default ProfileWizard;